import { modifiers } from "ui-tools"
import s from "./YourJourneysList.module.scss"

export type ConnectorType = "out" | "default" | null

export const getConnectorType = ({
  isFirst,
  hasHiddenItemsBefore,
}: {
  isFirst: boolean
  hasHiddenItemsBefore: boolean
}): ConnectorType => {
  if (isFirst && hasHiddenItemsBefore) return "out"
  if (isFirst) return null
  return "default"
}

export const JourneyConnector = ({ type }: { type: ConnectorType }) => {
  return (
    <div
      className={modifiers(s, "journeyItem__connector", {
        isOut: type === "out",
      })}
    />
  )
}
